function formatMarkdownToHtml(text) {
  if (text !== undefined) {
    const cleanedText = text.replace(/^-+/gm, "");
    const boldFormatted = cleanedText.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
    const italicFormatted = boldFormatted
      .replace(/__(.*?)__/g, "<i>$1</i>")
      .replace(/_(.*?)_/g, "<i>$1</i>");
    const lineBreakFormatted = italicFormatted.replace(/\n/g, "<br />");

    return lineBreakFormatted;
  }
}

export default formatMarkdownToHtml;
